const gallerySelector = document.querySelector('.gallery');
if (gallerySelector) {
	//@ts-ignore
	const mainCarousel = new Carousel(gallerySelector, {
		Dots: false,
		on: {
			ready: (carousel: any) => {
				carousel.$slides =
					carousel.$container.querySelectorAll('.carousel__slide');

				carousel.$slides.forEach((element: HTMLElement) => {
					if (element.getAttribute('aria-hidden') === 'true') {
						element.querySelector('a').tabIndex = -1;
					} else {
						element.querySelector('a').tabIndex = 0;
					}
				});
			},
			settle: (carousel: any) => {
				carousel.$slides =
					carousel.$container.querySelectorAll('.carousel__slide');

				carousel.$slides.forEach((element: HTMLElement) => {
					if (element.getAttribute('aria-hidden')) {
						element.querySelector('a').tabIndex = -1;
					} else {
						element.querySelector('a').tabIndex = 0;
						element.querySelector('a').focus();
					}
				});
			},
		},
	});

	const a11yGallery = () => {
		const galleries =
			document.querySelectorAll('.gallery-container') || null;
		if (galleries) {
			galleries.forEach((gallery) => {
				const btns = gallery.querySelectorAll('button');
				btns.forEach((btn) => {
					let txt: string;
					if (btn.classList.contains('is-next')) {
						//@ts-ignore
						txt = js_trad.NextItem;
					} else if (btn.classList.contains('is-prev')) {
						//@ts-ignore
						txt = js_trad.PrevItem;
					} else {
						//@ts-ignore
						txt = js_trad.SeeSlide;
					}
					btn.insertAdjacentHTML(
						'beforeend',
						`<span class="sr-only">${txt}</span>`
					);
				});
			});
		}
	};

	window.addEventListener('DOMContentLoaded', () => {
		a11yGallery();
	});

	//Thumbnails
	const thumbGallerySelector = document.querySelector('.gallery-thumb');
	if (thumbGallerySelector) {
		//@ts-ignore
		const thumbCarousel = new Carousel(thumbGallerySelector, {
			Sync: {
				target: mainCarousel,
				friction: 0.9,
			},
			Dots: false,
			Navigation: false,
			center: true,
			slidesPerPage: 1,
			infinite: false,
		});
	}

	//@ts-ignore
	Fancybox.bind('[data-fancybox="gallery"]', {
		Carousel: {
			on: {
				change: (that: { page: any }) => {
					mainCarousel.slideTo(
						mainCarousel.findPageForSlide(that.page),
						{
							friction: 0.9,
						}
					);
				},
			},
		},
	});
}
